var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTradingInstrumentIndices(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 89,
    viewBox: "0 0 88 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 89,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0707 70.0136L16.9727 68.9741L30.9438 54.2041L39.0803 54.334L43.0241 32.172L50.6106 44.1485L56.274 37.5755L71.0722 26.8239L71.9597 28.0468L57.233 38.746L50.4273 46.6841L43.831 36.2689L40.3435 55.8652L31.5855 55.7262L18.0707 70.0136Z",
    fill: "#057EE6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0009 34.7119H70.4899V27.9202H63.6992V26.4092H72.0009V34.7119Z",
    fill: "#057EE6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1139 72.6826H29.1602V74.1937H42.1139V72.6826Z",
    fill: "#111733"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0111 72.6835H44.0664V74.1945H57.0111V72.6835Z",
    fill: "#111733"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0111 68.6279H44.0664V70.139H57.0111V68.6279Z",
    fill: "#111733"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9186 72.6835H58.9648V74.1945H71.9186V72.6835Z",
    fill: "#111733"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9186 68.6279H58.9648V70.139H71.9186V68.6279Z",
    fill: "#111733"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9186 64.5699H58.9648V66.081H71.9186V64.5699Z",
    fill: "#111733"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9186 60.5195H58.9648V62.0306H71.9186V60.5195Z",
    fill: "#111733"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTradingInstrumentIndices);
export default __webpack_public_path__ + "static/media/trading-instrument-indices.a641ed0e184811ed664e00d76557d39b.svg";
export { ForwardRef as ReactComponent };